// src/components/Spinner.jsx
import React from "react";

const Spinner = () => {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-950/80 backdrop-blur-sm">
      <div className="w-16 h-16 border-[5px] border-cyan-500 border-t-transparent rounded-full animate-spin shadow-xl"></div>
    </div>
  );
};

export default Spinner;
